import apiClient from '../utils/apiClient';

export async function getStatus() {
  const response = await apiClient.get('/api/billing/status');
  return response.data;
}

export async function getSubscription() {
  const response = await apiClient.get('/api/billing/subscription');
  return response.data.subscription;
}

export async function initiatePayment() {
  const response = await apiClient.post('/api/billing/initiate', {});
  return response.data;
}

export async function updatePaymentMethod() {
  const response = await apiClient.post('/api/billing/update-payment-method', {});
  return response.data;
}

export async function cancelSubscription() {
  const response = await apiClient.post('/api/billing/cancel-subscription');
  return response.data;
}
